import { gql } from '__generated__'

/**
 * SIWS-style message the wallet must sign to be linked to the signed-in
 * account (DEV-321): names the site, the account and the wallet, lives ten
 * minutes, single use.
 */
export const LINK_WALLET_CHALLENGE = gql(`
  mutation linkWalletChallenge($walletAddress: String!) {
    linkWalletChallenge(walletAddress: $walletAddress) {
      challenge
    }
  }
`)
